import axios from 'axios';

import { createError } from '../error';
import {} from '../../types/models/error';
import { API_URL } from '../../constants';

export interface ILogRequest {
  level?: 'ERROR' | 'WARN' | 'INFO' | 'DEBUG';
  message: string;
  [key: string]: any;
}

/**
 * Post log details to be tracked by the api
 *
 * @param logRequest Log(s) to be sent to the back end for ingestion
 */
export async function postLogs(logRequest: ILogRequest | ILogRequest[]): Promise<void> {
  let logs = Array.isArray(logRequest) ? logRequest : [logRequest];
  logs = logs.map(({ level, ...rest }) => ({ level: level || 'INFO', ...rest }));
  try {
    const url = `${API_URL}/logs`;
    await axios.post(url, {
      logs,
    });
  } catch (error) {
    throw createError(error);
  }
}
postLogs.QUERY_KEY = 'postLogs';
